import { Category, CategoryType, SubCategoryType } from '../types';
import { METADATA_URL } from '../constants/api';

// カテゴリとサブカテゴリの関連付けを定義
const categoryToSubCategories: Record<CategoryType, SubCategoryType[]> = {
  '旅行記': [],
  'TIPS': [],
  'そのほか': []
};

// カテゴリ配列を生成
export const categories: Category[] = Object.entries(categoryToSubCategories).map(([name, subCategories], index) => ({
  id: `cat-${index}`,
  name: name as CategoryType,
  subCategories: subCategories
}));

// メタデータからカテゴリ情報を取得する関数
export const fetchCategoriesFromMetadata = async (): Promise<Category[]> => {
  try {
    const response = await fetch(METADATA_URL);
    
    if (!response.ok) {
      throw new Error(`メタデータの取得に失敗しました (${response.status})`);
    }
    
    const metadata = await response.json();
    
    // カテゴリとサブカテゴリを集計
    const categoryMap: Map<string, Set<string>> = new Map();
    
    metadata.forEach((article: any) => {
      const category = article.category;
      const subCategories = article.subcategory;
      
      if (!categoryMap.has(category)) {
        categoryMap.set(category, new Set());
      }
      
      // subCategoriesが配列の場合、各要素を追加
      if (Array.isArray(subCategories)) {
        subCategories.forEach(subCat => {
          if (subCat) {
            categoryMap.get(category)?.add(subCat);
          }
        });
      }
    });
    
    // カテゴリデータを構築
    let dynamicCategories: Category[] = Array.from(categoryMap.entries()).map(([categoryName, subCategoriesSet], index) => ({
      id: `dynamic-cat-${index}`,
      name: categoryName as CategoryType,
      subCategories: Array.from(subCategoriesSet) as SubCategoryType[]
    }));
    
    // "旅行記"カテゴリを最初に、"そのほか"カテゴリを最後に表示するようにソート
    dynamicCategories = dynamicCategories.sort((a, b) => {
      if (a.name === '旅行記') return -1;
      if (b.name === '旅行記') return 1;
      if (a.name === 'そのほか') return 1;
      if (b.name === 'そのほか') return -1;
      return a.name.localeCompare(b.name);
    });
    
    return dynamicCategories;
  } catch (error) {
    console.error('カテゴリデータの取得に失敗しました:', error);
    return categories; // エラー時はデフォルトカテゴリを返す
  }
};

// 初期化時にメタデータからカテゴリを取得
fetchCategoriesFromMetadata().then(dynamicCategories => {
  if (dynamicCategories.length > 0) {
    // 動的に取得したカテゴリでcategoriesを上書き
    (categories as Category[]).length = 0;
    dynamicCategories.forEach(cat => categories.push(cat));
  }
}).catch(error => {
  console.error('カテゴリの初期化に失敗しました:', error);
}); 